require('loading-attribute-polyfill');
import Scroll from 'animated-scroll-to'
import MainMenu from "./components/common/MainMenu";
import SubMenus from "./components/common/SubMenus";
import HashNav from './components/HashNav';
import Tab from "./components/common/Tab";
import Drawer from "./components/common/Drawer";
import Drop from "./components/common/Drop";
import Typer from './components/common/Typer';
import CarouselSwiper from "./components/common/CarouselSwiper";
import CarouselSave from "./components/common/CarouselSave";
import CarouselImg from "./components/common/CarouselImg";
import Search from "./components/common/Search";
import slider from "./components/common/Slider";
import Freeform from "./components/common/Freeform";
import Visitors from './components/Visitors';
import Lightbox from "./components/common/Lightbox";
import lightboxResource from "./components/common/LightboxResource";
import { bgPos } from "./helpers/global";
import { supportsFlexGap } from "./helpers/BrowserCompat";
import "./components/common/VideoBgHero";
if ( supportsFlexGap() ) {
  document.documentElement.classList.add("flexbox-gap");
} else {
  document.documentElement.classList.add("no-flexbox-gap");
}

const tab = new Tab;
const drawer = new Drawer;
new HashNav(drawer, tab)
new SubMenus();
new MainMenu();
new CarouselSwiper();
new CarouselSave();
new CarouselImg();
new Search();
new Freeform();
slider();

new Visitors();
new Lightbox();
new Drop();
lightboxResource();



/**
 * Get/Set Cookies
 */

function setCookie(cname, cvalue, exdays=0, path="")
{
	if ( exdays > 0 )
	{
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";" + path;
	}
	else
	{
		document.cookie = cname + "=" + cvalue + ";" + path;
	}
}

function getCookie(cname)
{
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++)
	{
		var c = ca[i];
		while (c.charAt(0) == ' ')
		{
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0)
		{
			 return c.substring(name.length, c.length);
		}
	}
	return "";
}


/**
 * Collaspse/Expand sections
 */

function collapseSection(element)
{
	// get the height of the element's inner content, regardless of its actual size
	var sectionHeight = element.scrollHeight;

	// temporarily disable all css transitions
	var elementTransition = element.style.transition;
	element.style.transition = '';

	// on the next frame (as soon as the previous style change has taken effect),
	// explicitly set the element's height to its current pixel height, so we
	// aren't transitioning out of 'auto'
	requestAnimationFrame(function()
	{
		element.style.height = sectionHeight + 'px';
		element.style.transition = elementTransition;

		// on the next frame (as soon as the previous style change has taken effect),
		// have the element transition to height: 0
		requestAnimationFrame(function()
		{
			element.style.height = 0 + 'px';
		});
	});

	// mark the section as "currently collapsed"
	element.setAttribute('data-collapsed', 'true');
}

function expandSection(element)
{
	// get the height of the element's inner content, regardless of its actual size
	var sectionHeight = element.scrollHeight;

	// have the element transition to the height of its inner content
	element.style.height = sectionHeight + 'px';

	// when the next css transition finishes (which should be the one we just triggered)
	element.addEventListener('transitionend', function(e) {
		// remove this event listener so it only gets triggered once
		element.removeEventListener('transitionend', arguments.callee);

		// remove "height" from the element's inline styles, so it can return to its initial value
		element.style.height = null;
	});

	// mark the section as "currently not collapsed"
	element.setAttribute('data-collapsed', 'false');
}


/**
 * Urgent Message
 */

// Get the urgent message
var urgent = document.getElementById('urgent-message-1');

// Get the urgent message
var urgent_close = document.getElementById('urgent-message-close-1');

// Get the urgent message
var urgent_cta1 = document.getElementById('urgent-message-cta-1');

// Check for the urgent message
if ( urgent )
{
	let root = document.documentElement;
	// Store Urgent Message height in a CSS variable on the HTML element.
	root.style.setProperty('--urgentMessageHeight', urgent.offsetHeight + 'px');
	window.addEventListener( 'resize', () =>
	{
		root.style.setProperty('--urgentMessageHeight', urgent.offsetHeight + 'px');
	});

	// When the user clicks on close (x), close the modal
	// The urgent message is hidden for 15 minutes
	if ( urgent_close )
	{
		urgent_close.onclick = function(event)
		{
			collapseSection(urgent);
			setCookie("dismissedUrgentMessage", 1, 0.01);
			root.style.setProperty('--urgentMessageHeight', '0px');
		}
	}

	// When the user clicks on the CTA
	// The urgent message is hidden for 7 days
	if ( urgent_cta1 )
	{
		urgent_cta1.onclick = function(event)
		{
			collapseSection(urgent);
			setCookie("dismissedUrgentMessage", 1, 7);
			root.style.setProperty('--urgentMessageHeight', '0px');
		}
	}
}